import React, { Component } from "react";
import { getWhatsAppSettings, updateWpConnectionError} from "../Common/Appcommon";
import axios from "axios";

class WhatsappApiService extends Component{

    domain = process.env.REACT_APP_CLOUD_API_URL;
    token = "";
    accountId = "";
    version = process.env.REACT_APP_CLOUD_API_VERSION;

    constructor(props) {
        super(props);
    }

    checkCredentials = async () => {
        if(this.token === "" || this.accountId === ""){
            let whatsappResponse = await getWhatsAppSettings();
            let wasettings = whatsappResponse[0];
            /*let users = whatsappResponse[1];*/
            let settings = {};
            if(wasettings.length > 0){
                settings = wasettings[0];
                this.token = settings.access_token;
                this.accountId = settings.account_id;
            }
        }
    }

    getLinkedPhoneNumbers = async (accountId='',token='',testApi=false) => {

        let result = [];
        let response = {
            status : 'success',
            message : '',
            data : []
        };

        try{

            if(!testApi){
                await this.checkCredentials();
                accountId = this.accountId;
                token = this.token;
            }

            if(accountId !== '' && token !== ''){
                try{
                    result = await axios.get(`${this.domain}/${this.version}/${accountId}/phone_numbers?access_token=${token}&fields=status,verified_name,code_verification_status,display_phone_number,platform_type,name_status,id,quality_rating,webhook_configuration,last_onboarded_time`);
                }catch (e) {
                    if(e.response !== undefined && e.response.data !== undefined && e.response.data.error !== undefined){
                        result = e.response.data.error;
                    }
                }
                
                if(result.status === 200 && result.data.data !== undefined){
                    response['data'] = result.data.data;

                    //If api test is successful then update the current credentials.
                    if(testApi){
                        this.accountId = accountId;
                        this.token = token;
                    }
                }else{

                    //Update Error in session to show header notification to user.
                    if(!testApi){
                        updateWpConnectionError('true');
                    }

                    response['status'] = 'failed';

                    if(result.code !== undefined && ( result.code >= 200 && result.code <= 299 )){
                        response['message'] = 'Please provide enough permissions to your whatsapp bussiness account';
                    }else{
                        response['message'] = result.message !== undefined ? result.message : '';
                    }
                }
            }else{
                response['status'] = 'failed';
                response['message'] = 'account Id or Token cannot be empty.';
            }

        }catch (e) {
        }

        return response;
    }

    getTemplates = async ()=>{

        let response = [];

        try{
            await this.checkCredentials();
            if(this.token !== "" && this.accountId !== ""){
                let result = await axios.get(`${this.domain}/${this.version}/${this.accountId}?access_token=${this.token}&fields=id,name,message_templates,phone_numbers`)
                
                if(result.status === 200 && (result.statusText === "" || result.statusText === "OK")){
                    response = result.data;
                }else{
                    updateWpConnectionError('true');
                }
            }
        }catch (e) {
        }
        return response;
    }
}

export default new WhatsappApiService;
